import { render, staticRenderFns } from "./Act_date.vue?vue&type=template&id=4024fbe6"
import script from "./Act_date.vue?vue&type=script&lang=js"
export * from "./Act_date.vue?vue&type=script&lang=js"
import style0 from "./Act_date.vue?vue&type=style&index=0&id=4024fbe6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports